























































import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';

// Components
import BaseDetails from '@/components/NewManOfTheMatch/Features/BaseDetails.vue';
import PickParentLeagues from '@/components/NewManOfTheMatch/PickParentLeagues.vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
	name: 'NewAddManOfTheMatche',

	components: {
		BaseDetails,
		PickParentLeagues,
	},

	data: () => ({
		step: 1,
		features: {
			city: null as string | null,
			country: null as string | null,
			displayName: null as string | null,
			location: null as string | null,
			manOfTheMatch: false,
			numberOfHalves: null as number | null,
			numberOfTeams: null as number | null,
			parentLeagues: [] as any[],
			parentLeaguesQualificationRules: null as any,
		},
		parentLeagues: [] as string[],
		teamsInMiniLeague: [] as any[],
	}),

	computed: {
		parentLeaguesInfo() {
			let string = ``;
			this.parentLeagues.map((pl: any) => {
				string = string + pl.display_name + ' ';
			});
			return string;
		},

		qualificationRulesInfo() {
			let string = ``;
			const rulesObj = this.features.parentLeaguesQualificationRules;
			for (let key in rulesObj) {
				rulesObj[key].map((n: number) => (string = `${string} ${n},`));
			}
			return string;
		},

		miniLeagueSetupInfo() {
			const bool = this.teamsInMiniLeague.reduce((acc: boolean, cur: any) => {
				if (cur.carry_points) acc = true;
				return acc;
			}, false);
			return bool ? 'Carry Points' : 'Not Carrying Points';
		},

		featuresAreSet() {
			if (this.features.displayName && this.features.location) {
				return true;
			} else {
				return false;
			}
		},
	},

	methods: {
		setStep(n: number) {
			this.step = n;
		},

		async confirmParentLeagues(parentLeagues: UUID[]) {
			console.log('confirmParentLeagues');
			const leaguePromises = parentLeagues.map(leagueId => {
				return this.$store.dispatch('getLeagueById', { leagueId });
			});
			const parentLeagueObjects = await Promise.all(leaguePromises);
			this.parentLeagues = [...parentLeagueObjects];
			this.features.parentLeagues = [...parentLeagues];
			this.step++;
		},

		async saveBaseDetails(updatedFeatures: any) {
			await this.createManOfTheMatch(updatedFeatures);
			this.$router.push({ name: 'man-of-the-matches' });
		},

		async createManOfTheMatch(updatedFeatures: any) {
			const manOfTheMatch = {
				id: uuidv4(),
				city_id: updatedFeatures.city,
				country_id: updatedFeatures.country,
				name: updatedFeatures.display_name,
			};

			const joins =
				this.parentLeagues &&
				this.parentLeagues.map((pl: any) => {
					return {
						league: pl.id,
						man_of_the_match: manOfTheMatch.id,
					};
				});
			await this.$store.dispatch('insertManOfTheMatch', manOfTheMatch);
			await this.$store.dispatch('insertLeagueManOfTheMatchJoin', joins);
		},

		nextStep() {
			this.step++;
		},

		previousStep() {
			this.step--;
		},
	},

	mounted() {
		this.$store.commit('setBreadcrumb', { root: 'Create', path: 'New Add Man of the match' });
		this.$store.commit('setLoadingState', false);
	},
});
